import { render, staticRenderFns } from "./ChangePasswordSuccessDialog.vue?vue&type=template&id=08fa72d6&lang=pug"
import script from "./ChangePasswordSuccessDialog.vue?vue&type=script&lang=js"
export * from "./ChangePasswordSuccessDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports